import { render, staticRenderFns } from "./TableComponent.vue?vue&type=template&id=c69a4e14&scoped=true"
import script from "./TableComponent.vue?vue&type=script&lang=js"
export * from "./TableComponent.vue?vue&type=script&lang=js"
import style0 from "./TableComponent.vue?vue&type=style&index=0&id=c69a4e14&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c69a4e14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c69a4e14')) {
      api.createRecord('c69a4e14', component.options)
    } else {
      api.reload('c69a4e14', component.options)
    }
    module.hot.accept("./TableComponent.vue?vue&type=template&id=c69a4e14&scoped=true", function () {
      api.rerender('c69a4e14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/component/TableComponent.vue"
export default component.exports